/**
 * 系统消息类型
 */
const messageType = {
	systemTypes: {
		// '2': '申请创建单位',
		'3': '企业审核',
		// '4': '被离职',
		'5': '组变更',
		'6': '其他通知',
		// '8': '公司被拒'
		'9': '关注信息变化',
		'24': '项目跟进提醒',
	},
	pushTypes: {}
};
/**
 * [{val:'1',name='申请加入单位'}...]
 */
messageType.systemTypeToArray = ()=>{
	let arr = [];
    for(let k in messageType.systemTypes){
    	let obj = {
    		val: k,
    		name: messageType.systemTypes[k]
    	};
        arr.push(obj);
    }
    return arr;
};

/**
 * 系统消息点击跳转
 * @param {object} router 路由对象
 * @param {object} item 相关参数
 * @returns {boolean}
 */
messageType.systemMsgJump = (router, item) =>{
	let showModal = false;
	switch(item.type){
		case '1':
            //申请加入单位
			switch(item.isApproval){
				case '2':
                    //加入单位待审
					router.push({
						name: 'company-member-application-detail',
						params: {
							id: item.id,
							uid: item.data.applyUid
						}
					});
					break;
				case '1':
				    //加入单位通过
				case '3':
				    //加入单位拒绝
					router.push({
						name: 'company-member-detail',
						params: {
							id: item.data.applyUid
						}
					});
					break;
			}
			break;
		case '2':
            //申请创建单位[暂无]
			break;
		case '3':
		    //是否审核成功跳通知列表页
			router.push({
				name: 'enterprise-report-detail',
				query: {
					id: item.otherid,
					type:item.report_type,
					source:1
				}
			});
			break;
		case '4':
			//被离职[暂无]
			break;
		case '5':
			//组变更跳通知列表页
            showModal = true;
			break;
		case '6':
			//其他通知跳通知列表页
            showModal = true;
			break;
		case '8':
		    //公司被拒跳通知列表页
			showModal = true;
			break;
		case '9':
			//更新提示跳转
			switch(item.other_type){
				case '1':
					//项目更新
					if (item.cate==1){
						router.push({
							name: 'land-item-all-detail',
							params: {
								id: item.otherid,
							}
						});
					}else if (item.cate==2){
						router.push({
							name: 'factory-item-all-detail',
							params: {
								id: item.otherid,
							}
						});
					}else if (item.cate==7){
						router.push({
							name: 'warehouse-item-all-detail',
							params: {
								id: item.otherid,
							}
						});
					}else if (item.cate==4){
						router.push({
							name: 'officebuilding-item-all-detail',
							params: {
								id: item.otherid,
							}
						});
					}

					break;
				case '2':
					//载体更新
					if (item.cate==1){
						router.push({
							name: 'land-carrier-all-detail',
							params: {
								id: item.index_id,
							}
						});
					}else if (item.cate==2){
						router.push({
							name: 'factory-carrier-all-detail',
							params: {
								id: item.index_id,
							}
						});
					}else if (item.cate==7){
						router.push({
							name: 'warehouse-carrier-all-detail',
							params: {
								id: item.index_id,
							}
						});
					}else if (item.cate==4){
						router.push({
							name: 'officebuilding-carrier-all-detail',
							params: {
								id: item.index_id,
							}
						});
					}
					break;
				case '3':
					//企业更新
					router.push({
						name: 'enterprise-all-detail',
						params: {
							id: item.otherid,
						}
					});
					break;
			}
			break;
		case '24':
            //项目更新
            if (item.cate==1){
                router.push({
                    name: 'land-item-all-detail',
                    params: {
                        id: item.otherid,
                    }
                });
            }else if (item.cate==2){
                router.push({
                    name: 'factory-item-all-detail',
                    params: {
                        id: item.otherid,
                    }
                });
            }else if (item.cate==7){
                router.push({
                    name: 'warehouse-item-all-detail',
                    params: {
                        id: item.otherid,
                    }
                });
            }else if (item.cate==4){
                router.push({
                    name: 'officebuilding-item-all-detail',
                    params: {
                        id: item.otherid,
                    }
                });
            }
            break;
		default:
			break;
	}
	return showModal;
};

/**
 * 推送消息点击跳转
 * @param {object} router 路由对象
 * @param {object} item 相关参数
 */
messageType.pushMsgJump = (router, item) =>{
	if(!item.itemid || item.itemid === "0"){
	    return false;
    }
    //跳转项目详情页（默认跳土地项目详情页，进去之后会自动根据类型更改跳转路由至正确的地址）
    router.push({
        name : "land-item-all-detail",
        params : {id : item.itemid},
    })
};

export default messageType;


// WEBPACK FOOTER //
// ./src/staticData/messageType.js